module.exports = __webpack_public_path__ + "img/graph_color.89a8e8c6.png";